"use client";

import React, { useEffect, useState, useRef } from "react";
import Api from "../../config/Api";
import { toast } from "react-toastify";
import Loader from "../Elements/Loader";
import Table from "../Elements/Table";
import TooltipWidget from "../Elements/TooltipWidget";
import dayjs from "dayjs";
import { BsFillEyeFill } from "react-icons/bs";
import ModalBox from "../Elements/ModalBox";
import ReactToPrint from "react-to-print";
import { FaPrint } from "react-icons/fa";
import logo from "../../assets/images/logo.png";

const PaymentHistory = () => {
  const [application, setApplication] = useState([]);
  const [isApplicationLoaded, setIsApplicationLoaded] = useState(false);
  const [isdetailModalShow, setIsdetailModalShow] = useState(false);
  const [detailModalData, setDetailModalData] = useState("");
  const componentRef = useRef();

  const detailModalShow = (d) => {
    setDetailModalData(d);
    setIsdetailModalShow(true);
  };
  const detailModalClose = () => {
    setDetailModalData("");
    setIsdetailModalShow(false);
  };

  const getApplication = async () => {
    try {
      const res = await Api("payment_history");
      if (res.data.status === 1) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setApplication(res.data.data);
        setIsApplicationLoaded(true);
      } else {
        toast.error(res.data.message, { position: toast.POSITION.BOTTOM_RIGHT });
        setIsApplicationLoaded(true);
      }
    } catch (error) {
      toast.error("Something went wrong!", { position: toast.POSITION.BOTTOM_RIGHT });
    }
  };

  useEffect(() => {
    getApplication();
  }, []);

  const columns = [
    {
      name: "#",
      selector: (props) => application.indexOf(props) + 1,
      sortable: true,
      width: "70px",
    },
    {
      name: "Application ID",
      selector: (row) => (!!row.application_no ? row.application_no : "-"),
      sortable: true,
      wrap: true,
    },
    {
      name: "Applicant Passport Photo",
      selector: (row) => (
        <img
          src={row.application?.applicant_default_img}
          alt="Applicant"
          style={{ height: "70px", width: "100px", objectFit: "cover" }}
        />
      ),
    },
    {
      name: "Payment Type",
      selector: (row) =>
        !!row.application?.payment_mode ? row.application?.payment_mode : "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Payment Type Other",
      selector: (row) =>
        !!row.application?.payment_type_other
          ? row.application?.payment_type_other
          : "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
      wrap: true,
      sortFunction: (a, b) => a?.amount - b?.amount,
    },
    {
      name: "Reference ID",
      selector: (row) => row.reference_id,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      wrap: true,
    },
    {
      name: "Date",
      selector: (row) => dayjs(row.created_at).format("DD MMM YYYY hh:mm A"),
      sortable: true,
      wrap: true,
      minWidth: "170px",
    },
    {
      name: "Action",
      selector: (row) => (
        <TooltipWidget title="View">
          <button
            className="btn btn-warning btn-sm"
            type="button"
            onClick={() => detailModalShow(row)}
          >
            <BsFillEyeFill />
          </button>
        </TooltipWidget>
      ),
      width: "70px",
    },
  ];

  return (
    <>
      <div className="bg-white p-3 rounded shadow">
        <div className="mb-2">
          <div className="row g-2">
            <div className="col-6 col-lg-4 col-md-4">
              <h5 className="text-dark">Payment History</h5>
            </div>
          </div>
        </div>

        <div>
          {isApplicationLoaded ? (
            <Table columns={columns} data={application} />
          ) : (
            <Loader />
          )}
        </div>
      </div>

      {/* Print Section (Hidden) */}
      <div
        ref={componentRef}
        style={{ padding: "20px", margin: "40px 10px", display: "none" }}
        className="print-section"
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th colSpan={2} style={{ textAlign: "center", padding: "10px" }}>
                <img src={logo} style={{ height: "120px", marginBottom: "30px" }} alt="logo" />
              </th>
            </tr>
            <tr>
              <th
                colSpan={2}
                style={{
                  textAlign: "center",
                  padding: "10px",
                  color: "#252372",
                  fontSize: "25px",
                  fontWeight: "500",
                }}
              >
                Payment Receipt
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td style={{ padding: "10px 10px 0px 10px" }} colSpan={2}>
                <h5 style={{ margin: 0, color: "#000000de", fontWeight: "500" }}>
                  Application ID: {detailModalData?.application_no}
                </h5>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "10px", verticalAlign: "top" }}>
                <p style={{ margin: "2px 0", fontSize: "18px" }}>{detailModalData?.account_holder_name}</p>
              </td>
              <td style={{ padding: "10px", textAlign: "end" }}>
                <p>{dayjs(detailModalData?.created_at).format("DD MMM YYYY hh:mm A")}</p>
                <p>{detailModalData?.contact}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: "5px 10px" }}>
                <p>Account Number: {detailModalData?.account_no}</p>
                <p>IFSC: {detailModalData?.ifsc}</p>
                <p>
                  Payment Type:{" "}
                  {detailModalData?.application?.payment_mode
                    ? detailModalData?.application?.payment_mode
                    : "-"}
                </p>
              </td>
              <td style={{ textAlign: "end", padding: "5px 10px" }}>
                <h3 style={{ color: "#252372" }}>₹{detailModalData?.amount}</h3>
                <h6 style={{ color: "#387123", fontSize: "18px" }}>{detailModalData?.status}</h6>
              </td>
            </tr>

            <tr>
              <td style={{ border: "1px solid #d8d8ff", padding: "10px" }}>
                Reference ID
              </td>
              <td style={{ border: "1px solid #d8d8ff", padding: "10px" }}>
                {detailModalData?.reference_id}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #d8d8ff", padding: "10px" }}>
                Payment Type Other
              </td>
              <td style={{ border: "1px solid #d8d8ff", padding: "10px" }}>
                {detailModalData?.application?.payment_type_other || "-"}
              </td>
            </tr>

            <tr style={{ height: "30px" }}></tr>

            <tr>
              <td style={{ textAlign: "center", border: "1px solid #d8d8ff", padding: "10px" }}>
                <h6 style={{ color: "#252372" }}>Uploaded Photo</h6>
                <img
                  src={detailModalData?.application?.applicant_default_img}
                  alt="Uploaded"
                  style={{ maxWidth: "100px", height: "auto" }}
                />
              </td>
              <td style={{ textAlign: "center", border: "1px solid #d8d8ff", padding: "10px" }}>
                <h6 style={{ color: "#252372" }}>Captured Photo</h6>
                <img
                  src={detailModalData?.application?.applicant_img}
                  alt="Captured"
                  style={{ maxWidth: "100px", height: "auto" }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Modal Box */}
      <ModalBox
        show={isdetailModalShow}
        hide={detailModalClose}
        title="Payment Detail"
        size="lg"
      >
        <ReactToPrint
          trigger={() => (
            <div className="text-end mb-3">
              <button type="button" className="btn btn-success btn-sm px-2">
                <FaPrint /> Print
              </button>
            </div>
          )}
          content={() => componentRef.current}
        />

        <div className="p-3">
          <div className="row py-2 mb-3 border-1" style={{ border: "1px solid #ddd" }}>
            <div className="col-6 text-center">
              <h6 style={{ color: "#252372" }}>Uploaded Photo</h6>
              <img
                src={detailModalData?.application?.applicant_default_img}
                alt="Applicant Img"
                style={{ maxWidth: "100px", height: "auto" }}
              />
            </div>
            <div className="col-6 text-center">
              <h6 style={{ color: "#252372" }}>Captured Photo</h6>
              <img
                src={detailModalData?.application?.applicant_img}
                alt="Applicant Img"
                style={{ maxWidth: "100px", height: "auto" }}
              />
            </div>
          </div>

          <div className="row g-3">
            {[
              ["Application ID", detailModalData?.application_no],
              ["Name", detailModalData?.account_holder_name],
              ["Contact Number", detailModalData?.contact],
              ["Amount", `₹${detailModalData?.amount}`],
              ["Account Number", detailModalData?.account_no],
              ["IFSC", detailModalData?.ifsc],
              [
                "Payment Type",
                detailModalData?.application?.payment_mode || "-",
              ],
              [
                "Payment Type Other",
                detailModalData?.application?.payment_type_other || "-",
              ],
              ["Reference ID", detailModalData?.reference_id],
              ["Status", detailModalData?.status],
              [
                "Date",
                dayjs(detailModalData?.created_at).format("DD MMM YYYY hh:mm A"),
              ],
            ].map(([label, value], i) => (
              <div key={i} className="col-6 col-lg-6">
                <div className="px-3 py-2 rounded paylistst">
                  <label className="small fw-bold mb-1">{label}:</label>
                  <p>{value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ModalBox>
    </>
  );
};

export default PaymentHistory;
